// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
// NgRx reducers
import { getLogger } from 'NewAngular/state/logger';
// Modules
import { ConfigModule } from 'NewAngular/config/config.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
// Components
import { GlossaryIndexComponent } from 'GlossaryApp/ts/apps/glossary-index-app/components/glossary-index/glossary-index.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [GlossaryIndexComponent, TopBarNavComponent, SideMenuComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        IconModule,
        NavigationModule,
        IconSearchAutocompleteModule,
        SideMenuModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
